import { render, staticRenderFns } from "./FormCertInput.vue?vue&type=template&id=39ab3e43&"
import script from "./FormCertInput.vue?vue&type=script&lang=js&"
export * from "./FormCertInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports